import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./FareCardHeader.module.scss";
import {
  PromoBadgeContent,
  PromoBadges,
  PromoBadgesProps
} from "../../PromoBadges/PromoBadges";
import { arrayIsNotEmpty } from "../../utils/checks";
import clsx from "clsx";
import { HilightedBadge } from "./HilightedBadge";

export type FareCardHeaderProps = {
  title: string | ReactElement;
  subtitle?: string | ReactElement;
  description?: string | ReactElement;
  backgroundColor?: "neutral05" | "white" | "neutral01";
  variant?: "vertical" | "horizontal";
  hilighted?: boolean;
  hilightedLabel?: string;
} & (
  | { withPromos?: false; promos?: never; onPromoBadgeClicked?: never }
  | {
      withPromos: true;
      promos?: PromoBadgeContent[];
      onPromoBadgeClicked?: PromoBadgesProps["onPromoBadgeClicked"];
    }
);

export const FareCardHeader: React.FC<
  PropsWithChildren<FareCardHeaderProps>
> = ({
  children,
  title,
  subtitle,
  description,
  withPromos = false,
  hilighted = false,
  hilightedLabel,
  promos,
  onPromoBadgeClicked,
  backgroundColor = "neutral05",
  variant = "vertical"
}) => {
  return (
    <header
      className={clsx(styles.header, {
        [styles.hilighted]: hilighted,
        [styles.withPromos]: withPromos,
        [styles.withEmptyPromos]:
          !arrayIsNotEmpty(promos) && variant === "vertical",
        [styles.horizontalHeader]: variant === "horizontal",
        [styles.whiteBackground]: backgroundColor === "white",
        [styles.neutral01Background]: backgroundColor === "neutral01"
      })}
    >
      {hilighted && hilightedLabel && (
        <HilightedBadge>{hilightedLabel}</HilightedBadge>
      )}
      {withPromos && arrayIsNotEmpty(promos) && (
        <PromoBadges
          promos={promos}
          className={styles.promos}
          inverted={true}
          onPromoBadgeClicked={onPromoBadgeClicked}
        />
      )}
      <div
        className={clsx({
          [styles.headerContent]: variant === "vertical",
          [styles.horizontalHeaderContent]: variant === "horizontal"
        })}
      >
        <div
          className={clsx(styles.titleWrapper, {
            [styles.horizontalTitleWrapper]: variant === "horizontal"
          })}
        >
          <div className={styles.title}>{title}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
        {description && <div className={styles.description}>{description}</div>}
        {children}
      </div>
    </header>
  );
};
